import { render, staticRenderFns } from "./SafetyIsland.vue?vue&type=template&id=a62d04fe&scoped=true"
import script from "./SafetyIsland.vue?vue&type=script&lang=js"
export * from "./SafetyIsland.vue?vue&type=script&lang=js"
import style0 from "./SafetyIsland.vue?vue&type=style&index=0&id=a62d04fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62d04fe",
  null
  
)

export default component.exports